import { Order } from "@/types";
import { useGetClaimsByOrderId } from "@/services/Claims";
import NewClaim from "./NewClaim";
import ViewClaim from "./ViewClaim";

interface ClaimsTabProps {
  order: Order;
}

const ClaimsTab = ({ order }: ClaimsTabProps) => {
  const claims = useGetClaimsByOrderId(order.id);
  return (
    <>
      <ViewClaim claim={claims} />
      {(!claims.data || claims.data.length < 1) && <NewClaim order={order} />}
    </>
  );
};

export default ClaimsTab;
